<script>
import Modal from '../../../components/Modal.vue'

export default {
    components: {
        Modal
    },

    props: {
        jobApplication: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            fail_reason: '',
        }
    },

    methods: {
        toggleModal() {
            this.$refs.modal.toggle()
        },
        fail() {
            this.$emit('submit', this.fail_reason)
        }
    }
}
</script>

<template>
    <modal ref="modal" heading="Fail Applicant">
        <h1>Failing {{ jobApplication.user.full_name }}</h1>

        <div class="mb-4">
            <label>Please specify the reason for failing this candidate. Please note that this reason will be included in the communications sent to this candidate.</label>
            <input type="text" name="fail_reason" class="bg-white rounded" v-model="fail_reason">
        </div>

        <div class="grid-x grid-padding-x align-right">
            <div class="cell shrink">
                <button class="button recycle px-5" type="button" @click="fail">Fail</button>
            </div>

            <div class="cell shrink">
                <button @click="toggleModal" class="button warning" type="button">Close</button>
            </div>
        </div>
    </modal>
</template>